export function updateProcessTypeChangedAlert(value: string, originalValue: string) {
    if (value !== originalValue) {
        $('#processTypeChangedAlert').show();
    } else {
        $('#processTypeChangedAlert').hide();
    }
}
